import { type ColorToken, type IconName } from '@cumlaude/shared-components-icons';

export const SENTIMENT_ICON: Partial<Record<number, { name: IconName; color: ColorToken }>> = {
	1: { name: 'thumb-up', color: 'positive-1' },
	[-1]: { name: 'thumb-down', color: 'error-1' },
};
